<template>
  <div class="invoice-pagination d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mt-4">
    <p class="mb-0 text-muted small">
      Showing <strong>{{ firstItem }}</strong>-<strong>{{ lastItem }}</strong> of <strong>{{ total }}</strong>
      projects
    </p>
    <div class="d-flex align-items-center gap-3">
      <nav aria-label="Invoice projects pagination">
        <ul class="pagination pagination-sm mb-0">
          <li
            :class="{ disabled: currentPage <= 1 }"
            class="page-item"
          >
            <button
              class="page-link"
              type="button"
              aria-label="Previous page"
              :disabled="currentPage <= 1"
              @click="changePage(currentPage - 1)"
            >
              <i class="fa fa-chevron-left" />
            </button>
          </li>
          <li
            v-for="page in visiblePages"
            :key="`page-${page}`"
            :class="{ active: page === currentPage, disabled: page === '...' }"
            class="page-item"
          >
            <span
              v-if="page === '...'"
              class="page-link"
            >...</span>
            <button
              v-else
              class="page-link"
              type="button"
              @click="changePage(page)"
            >
              {{ page }}
            </button>
          </li>
          <li
            :class="{ disabled: currentPage >= totalPages }"
            class="page-item"
          >
            <button
              class="page-link"
              type="button"
              aria-label="Next page"
              :disabled="currentPage >= totalPages"
              @click="changePage(currentPage + 1)"
            >
              <i class="fa fa-chevron-right" />
            </button>
          </li>
        </ul>
      </nav>
      <select
        :value="perPage"
        class="form-select form-select-sm per-page-select"
        aria-label="Projects per page"
        @change="$emit('per-page-change', Number($event.target.value))"
      >
        <option :value="5">
          5 / page
        </option>
        <option :value="10">
          10 / page
        </option>
        <option :value="20">
          20 / page
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
    name: "InvoicePagination",
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        total: {
            type: Number,
            default: 0,
        },
        perPage: {
            type: Number,
            default: 10,
        },
    },
    computed: {
        totalPages() {
            return Math.max(1, Math.ceil(this.total / this.perPage));
        },
        firstItem() {
            return this.total === 0 ? 0 : ((this.currentPage - 1) * this.perPage) + 1;
        },
        lastItem() {
            return Math.min(this.currentPage * this.perPage, this.total);
        },
        visiblePages() {
            if (this.totalPages <= 7) {
                return Array.from({ length: this.totalPages }, (_, index) => index + 1);
            }
            if (this.currentPage <= 4) {
                return [1, 2, 3, 4, 5, "...", this.totalPages];
            }
            if (this.currentPage >= this.totalPages - 3) {
                return [1, "...", this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages];
            }

            return [1, "...", this.currentPage - 1, this.currentPage, this.currentPage + 1, "...", this.totalPages];
        },
    },
    methods: {
        changePage(page) {
            if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
                this.$emit("page-change", page);
            }
        },
    },
};
</script>

<style scoped>
.invoice-pagination .page-link {
    border-color: #dfe6f0;
    color: #4B5563;
    min-width: 34px;
    text-align: center;
}

.invoice-pagination .active .page-link {
    background: #4c78dd;
    border-color: #4c78dd;
    color: #fff;
}

.per-page-select {
    min-width: 100px;
}
</style>
